import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent } from '@mui/material';
import { useContext } from 'react';
import { AppMainViewContext } from '../../../../../ContextProviders/AppContextProvider';
import { isAdminRole } from '../../../../../helpers/access';
export const AdminCardWrapper = ({ cardProps, cardContentProps, cardHeader, children }) => {
    const [{ userSelectedGroup }] = useContext(AppMainViewContext);
    return !isAdminRole(userSelectedGroup) ? (_jsxs(Card, { elevation: 3, ...cardProps, children: [cardHeader, _jsx(CardContent, { sx: { padding: 0, ['&:last-child']: { padding: 2 } }, ...cardContentProps, children: children })] })) : (children);
};
